import React, { useState, useEffect } from "react";
import axios from "axios";
import { ApiBaseUrl } from '../constants/global';

const Sameday = () => {
    /*const apiBaseUrl = "http://localhost:3000";*/
    /*const apiBaseUrl = "https://oz-config.thinkingbigbusiness.com.au";*/
    /*Initialize state using useState hook*/
    const [formData, setFormData] = useState({
        id: '',
        amount: '',
        path: '',
        zone: ''
    });
    const fetchInfo = () => {
        var pathval = document.getElementById('sameday-path').value;
        var postdata = {"path": pathval};
        const responce = axios
          .post(`${ApiBaseUrl}/getshipdata`, postdata)
          .then(response => {
                if (response.data.freeshippingdata.amount > 0) {
                    /*console.log("fetchInfo"+response.data);*/
                    setFormData({
                        id: response.data.freeshippingdata.id,
                        amount: response.data.freeshippingdata.amount,
                        path: response.data.freeshippingdata.path,
                        zone: response.data.freeshippingdata.zone
                    });
                }
            })
            .catch(error => {
                setFormData({id: '',amount: '', path: pathval});
                console.log(error)
            });
        return responce;
    };
    useEffect(() => {
        fetchInfo();
    }, []);
    /*Handle form input changes*/
    const handleChange = (event) => {
        const { name, value } = event.target;
        if (value && parseFloat(value) > 0){
            document.getElementById("sameday-sbt-btn").style.display = "inline-flex";
        } else {
            document.getElementById("sameday-sbt-btn").style.display = "none";
        }
        setFormData({
            ...formData,
            [name]: value
        });
    };

    /* Handle form submission*/
    const handleSubmit = (event) => {
        event.preventDefault();
        var url;
        var html;
        var msgContainer = document.getElementById('page-message-sameday');
        if (formData.id !== "") {
            url = `${ApiBaseUrl}/updatesameday`;
            html = "<p>Sameday Shipping Data successfully updated.</p>";
        } else {
            url = `${ApiBaseUrl}/addsameday`;
            html = "<p>Sameday Shipping Data successfully added.</p>";
        }
        axios
            .post(url, formData)
            .then((response) => {
                /*console.log(response.data);*/
                setFormData({
                    id: response.data.freeshippingdata.id,
                    amount: response.data.freeshippingdata.amount,
                    path: response.data.freeshippingdata.path,
                    zone: response.data.freeshippingdata.zone
                });
                msgContainer.style.display = "block";
                msgContainer.innerHTML = html;
                msgContainer.classList.add("success");
                document.getElementById("sameday-sbt-btn").style.display = "none";
                setTimeout(function(){
                    msgContainer.style.display = "none";
                },10000);
            })
            .catch((error) => {
                msgContainer.style.display = "block";
                msgContainer.innerHTML = error;
                msgContainer.classList.add("error");
                document.getElementById("sameday-sbt-btn").style.display = "none";
                setTimeout(function(){
                    msgContainer.style.display = "none";
                },10000);
            });
    };
    /*const [file, setFile] = useState(null);
    const handleFileChange = (event) => {
        setFile(event.target.files[0]);

    };
    const handleUpload = async () => {
        if (!file) {
            alert("Please select a file first!");
            return;
        }
        const formData = new FormData();
        formData.append("file", file);
        console.log(formData);
        try {
            const response = await axios.post(`${apiBaseUrl}/uploadsamedaycsv`, formData, {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
            });
            alert(response.data.message);
        } catch (error) {
            console.error("Error uploading file:", error);
            alert("File upload failed.");
        }
    };*/
    return (
        <div className="config-main">
            <h2>Same Day Shipping Configuration</h2>
            <div>
                <div id="page-message-sameday" className="page-message"></div>
                <form onSubmit={handleSubmit}>
                    <div>
                        <input
                            type="hidden"
                            name="id"
                            placeholder="id"
                            defaultValue={formData.id}
                        />
                        <input
                            type="hidden"
                            name="path"
                            placeholder="path"
                            id="sameday-path"
                            defaultValue="sameday"
                        />
                    </div>
                    <div className="field">
                        <label htmlFor="amount">Additional charges for same-day delivery in %</label>
                        <input
                            type="number"
                            id="amount"
                            name="amount"
                            placeholder="Enter Value"
                            defaultValue={formData.amount}
                            onChange={handleChange}
                            max="99"
                        />
                    </div>
                    {/* <div className="field">
                        <label htmlFor="sameday-zone-range">Enter Sameday Delivery Zone 1 Range<br /><small>Add zones separated by commas (,) and<br />ranges separated by dashe (-);<br />spaces are not allowed.</small></label>
                        <textarea
                            id="sameday-zone-range"
                            name="zone"
                            placeholder="Enter Sameday Delivery Zone Range"
                            defaultValue={formData.zone}
                            onChange={handleChange}
                        ></textarea>
                    </div> */}
                    <div>
                        <button id="sameday-sbt-btn" style={{display:"none"}}>Save</button>
                    </div>
                </form>
                {/*<div className="field">
                    <label>Upload Sameday Delivery Shipping Zone CSV<br /></label>
                    <input type="file" accept=".csv" onChange={handleFileChange} />
                    <button onClick={handleUpload}>Upload</button>
                </div>*/}
            </div>
        </div>
    );
};
 
export default Sameday;